import { createAsyncThunk } from '@reduxjs/toolkit';
import portalApi from '../../core/api/portal.api';
import { Participant, ParticipantResponse, GraphQlError } from '../../core/types/common.types';

export const getParticipantThunk = createAsyncThunk<
  // Return type of the payload creator
  Participant,
  // First argument to the payload creator
  string,
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('participant', async (id, thunkApi) => {
  const response: ParticipantResponse = await portalApi.getParticipant(id);
  const errors = response.errors;
  const participant = response.data?.getParticipant;

  if (errors) {
    return thunkApi.rejectWithValue(errors);
  }
  return participant as Participant;
});
